// סימון שכבר ביקשנו מהמשתמש הרשאת מיקרופון - כדי לבקש פעם אחת בלבד
const MIC_PRIMED_KEY = 'mic_permission_primed';

export type MicPermissionState = 'granted' | 'denied' | 'prompt' | 'unknown';

export class MicrophoneService {
  /** מצב ההרשאה הנוכחי. 'unknown' כשהדפדפן לא תומך ב-Permissions API */
  static async getPermissionState(): Promise<MicPermissionState> {
    try {
      const permissionStatus = await navigator.permissions.query({
        name: 'microphone' as PermissionName,
      });
      return permissionStatus.state as MicPermissionState;
    } catch (error) {
      console.warn('לא ניתן לבדוק את מצב ההרשאה:', error);
      return 'unknown';
    }
  }

  static wasPrimed(): boolean {
    return !!localStorage.getItem(MIC_PRIMED_KEY);
  }

  static markPrimed(): void {
    localStorage.setItem(MIC_PRIMED_KEY, 'true');
  }

  /**
   * מבקש הרשאת מיקרופון פעם אחת, מתוך לחיצה של המשתמש.
   * הזרם נסגר מיד - המטרה היא רק להוציא את בקשת ההרשאה מהדפדפן
   * לפני שהמשתמש מגיע למסך השינון, ולא להתחיל הקלטה.
   */
  static async requestPermission(): Promise<boolean> {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      stream.getTracks().forEach((track) => track.stop());
      this.markPrimed();
      return true;
    } catch (error) {
      console.warn('בקשת הרשאת מיקרופון נדחתה:', error);
      // גם דחייה נחשבת "נשאל" - לא מציקים למשתמש שוב, יש הסבר במסך
      this.markPrimed();
      return false;
    }
  }

  static async checkMicrophonePermission(): Promise<void> {
    const state = await this.getPermissionState();
    if (state !== 'granted' && state !== 'unknown') {
      this.showMicrophonePermissionAlert();
    }
  }

  static showMicrophonePermissionAlert(): void {
    alert('אין הרשאה לשימוש במיקרופון. אנא עדכן את ההגדרות כדי לאפשר לדפדפן להשתמש במיקרופון.');

    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.includes('android')) {
      window.open('intent://#Intent;action=android.settings.APPLICATION_DETAILS_SETTINGS;end', '_blank');
    } else if (userAgent.includes('iphone') || userAgent.includes('ipad')) {
      alert('במכשירי iOS, אנא עבור להגדרות > פרטיות > מיקרופון ואפשר לדפדפן גישה למיקרופון.');
    }
  }

  static isSpeechRecognitionSupported(): boolean {
    // return !!(window.webkitSpeechRecognition || window.SpeechRecognition);
    return true
  }

  static createSpeechRecognition(): any {
    // nm_2
    // const SpeechRecognition = window.webkitSpeechRecognition || window.SpeechRecognition;

    // if (!SpeechRecognition) {
    //   console.warn("SpeechRecognition not supported");
    //   return null;
    // }

    // const recognition = new SpeechRecognition();
    // recognition.lang = 'he-IL';
    // recognition.maxAlternatives = 1;
    // recognition.interimResults = true;
    // recognition.continuous = true;

    // return recognition;

  }
}
